import { ReactNode, createContext, useContext } from "react";

const NavbarDropdownMenuCloseContext = createContext<() => void>(() => undefined);

export const NavbarDropdownMenuCloseProvider = ({
  closeMenu,
  children,
}: {
  closeMenu: () => void;
  children: ReactNode;
}) => {
  return (
    <NavbarDropdownMenuCloseContext.Provider value={closeMenu}>{children}</NavbarDropdownMenuCloseContext.Provider>
  );
};

export const useNavbarDropdownMenuClose = () => useContext(NavbarDropdownMenuCloseContext);
